import React from 'react';
const Dentists = () => <div className="service-page"><h1>Dentists</h1><p>Expert dental care and oral health services.</p></div>;
export default Dentists;
